<template>
  <app-modal
    :value="lazyValue"
    hide-footer
    :closable="false"
    title="modal.update_available.title"
    name="Update App"
  >
    <b-form @submit.prevent="onSubmit">
      <p>
        <strong>{{ "modal.update_available.message" | trans }}</strong>
      </p>

      <div class="buttons">
        <b-button type="submit" variant="primary" block :disabled="submitted">{{
          "modal.update_available.button" | trans
        }}</b-button>
      </div>
    </b-form>
  </app-modal>
</template>

<script>
import AppModal from "@/components/modal/Modal";

export default {
  name: "AppUpdateAvailableModal",
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: { AppModal },
  watch: {
    value: {
      handler(value) {
        this.lazyValue = value;
      },
      immediate: true,
    },
  },
  methods: {
    onSubmit() {
      this.submitted = true;
      this.$emit("reload");
    },
  },
  data() {
    return {
      lazyValue: this.value,
      submitted: false,
    };
  },
};
</script>
